import { useNavigate } from 'react-router-dom';

export default function OffreGratuite() {
  const navigate = useNavigate();

  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="py-20 bg-gradient-to-br from-teal-50 to-blue-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="bg-white rounded-3xl shadow-2xl overflow-hidden border-2 border-teal-200">
          <div className="grid grid-cols-1 lg:grid-cols-2">
            {/* Left Side - Offer Details */}
            <div className="p-12 bg-gradient-to-br from-white to-teal-50">
              <div className="inline-flex items-center px-4 py-2 bg-green-100 text-green-800 rounded-full text-sm font-bold mb-6">
                <i className="ri-gift-line mr-2"></i>
                OFFRE DE BIENVENUE
              </div>
              
              <h2 className="text-4xl md:text-5xl font-black text-gray-900 mb-6 leading-tight">
                Testez Gratuitement<br />
                <span className="text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-blue-600">
                  3 Leads Offerts
                </span>
              </h2>

              <p className="text-xl text-gray-700 mb-8 leading-relaxed">
                Découvrez la qualité de nos leads sans engagement. Recevez 3 demandes clients qualifiées pour tester notre service.
              </p>

              <div className="space-y-4 mb-8">
                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">3 Leads Qualifiés Gratuits</h4>
                    <p className="text-gray-600 text-sm">Coordonnées complètes de clients prêts à acheter</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Aucune Carte Bancaire</h4>
                    <p className="text-gray-600 text-sm">Pas de paiement, pas d'engagement</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Livraison Immédiate</h4>
                    <p className="text-gray-600 text-sm">Accès instantané après inscription</p>
                  </div>
                </div>

                <div className="flex items-start gap-3">
                  <div className="w-8 h-8 bg-green-100 rounded-lg flex items-center justify-center flex-shrink-0 mt-1">
                    <i className="ri-check-line text-green-600 text-lg"></i>
                  </div>
                  <div>
                    <h4 className="font-bold text-gray-900 mb-1">Valeur Réelle : 105€</h4>
                    <p className="text-gray-600 text-sm">3 leads × 35€ = économie de 105€</p>
                  </div>
                </div>
              </div>

              <button 
                onClick={() => {
                  navigate('/inscription-candidat');
                  window.scrollTo({ top: 0, behavior: 'smooth' });
                }}
                className="w-full bg-gradient-to-r from-teal-600 to-blue-600 text-white px-8 py-5 rounded-xl text-xl font-black hover:from-teal-700 hover:to-blue-700 transition-all transform hover:scale-105 shadow-xl flex items-center justify-center gap-3 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-gift-line text-2xl"></i>
                Profiter de l'Offre Gratuite
                <i className="ri-arrow-right-line text-2xl"></i>
              </button>

              <p className="text-center text-sm text-gray-500 mt-4">
                <i className="ri-shield-check-line mr-1"></i>
                Sans engagement • Aucune carte requise
              </p>
            </div>

            {/* Right Side - Visual */}
            <div className="bg-gradient-to-br from-teal-600 to-blue-600 p-12 flex items-center justify-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-10">
                <div className="absolute top-10 left-10 w-40 h-40 bg-white rounded-full blur-3xl"></div>
                <div className="absolute bottom-10 right-10 w-60 h-60 bg-white rounded-full blur-3xl"></div>
              </div>

              <div className="relative z-10 text-center">
                <div className="w-32 h-32 bg-white rounded-full flex items-center justify-center mx-auto mb-8 shadow-2xl">
                  <span className="text-6xl font-black text-transparent bg-clip-text bg-gradient-to-r from-teal-600 to-blue-600">3</span>
                </div>

                <h3 className="text-3xl font-bold text-white mb-4">Leads Gratuits</h3>
                <p className="text-xl text-blue-100 mb-8">Valeur : 105€</p>

                <div className="grid grid-cols-1 gap-4 max-w-sm mx-auto">
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                    <div className="text-2xl font-bold text-white mb-1">100%</div>
                    <div className="text-sm text-blue-100">Qualifiés</div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                    <div className="text-2xl font-bold text-white mb-1">0€</div>
                    <div className="text-sm text-blue-100">Sans Frais</div>
                  </div>
                  <div className="bg-white/10 backdrop-blur-sm rounded-xl p-4 border border-white/20">
                    <div className="text-2xl font-bold text-white mb-1">24h</div>
                    <div className="text-sm text-blue-100">Livraison</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Info */}
        <div className="mt-12 text-center">
          <p className="text-gray-600 mb-4">
            <strong className="text-gray-900">Offre limitée :</strong> Seulement 50 places disponibles ce mois-ci
          </p>
          <div className="flex items-center justify-center gap-8 text-sm text-gray-500">
            <div className="flex items-center gap-2">
              <i className="ri-user-line"></i>
              <span>247 professionnels inscrits</span>
            </div>
            <div className="flex items-center gap-2">
              <i className="ri-star-line"></i>
              <span>4.8/5 satisfaction</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}